import { FC, useState } from "react";
import { LinkPage } from "../../common/components/LinkPage";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import { Button } from "../../forms/components/Button";
import { t } from "../../common/miscellaneous/t";

export const NoRouteButtons: FC = () => {
  const [count, setCount] = useState(0);

  return (
    <div className="tw-flex tw-gap-3">
      <Button
        disabled={count > 0}
        className="tw-px-6"
        data-testid={DataTestids.NotFoundBackButton}
        onClick={() => {
          setCount((value) => value + 1);
          window.history.back();
        }}
      >
        {t("mk-hc-previous-page")}
      </Button>
      <LinkPage data-testid={DataTestids.NotFoundHomeLink} to="/purchases">
        <Button
          className="tw-px-6"
          data-testid={DataTestids.NotFoundHomeButton}
        >
          {t("mk-hc-home-page")}
        </Button>
      </LinkPage>
    </div>
  );
};
